module.exports = __webpack_public_path__ + "cf16571a2bafebc5e2cb648d9a04814b.svg";